import type { AppRouter } from "@klarify/api";
import { TRPCClientError } from "@trpc/client";

export const SESSION_EXPIRED_MESSAGE =
	"Your session expired. Please sign in again to continue.";

const GENERIC_UNAUTHORIZED_MESSAGES = new Set([
	"unauthorized",
	"failed unauthorized",
]);

function getResponseStatus(error: TRPCClientError<AppRouter>) {
	const response = error.meta?.response;
	if (
		response &&
		typeof response === "object" &&
		"status" in response &&
		typeof response.status === "number"
	) {
		return response.status;
	}
	return undefined;
}

export function isSessionExpiredTRPCError(error: TRPCClientError<AppRouter>) {
	const message = error.message.trim().toLowerCase();
	const isGenericUnauthorizedMessage =
		GENERIC_UNAUTHORIZED_MESSAGES.has(message);

	if (!isGenericUnauthorizedMessage) {
		return false;
	}

	return (
		error.data?.code === "UNAUTHORIZED" || getResponseStatus(error) === 401
	);
}

export function toSessionExpiredTRPCError(error: TRPCClientError<AppRouter>) {
	if (!isSessionExpiredTRPCError(error)) {
		return error;
	}

	if (error.shape) {
		return TRPCClientError.from<AppRouter>(
			{
				error: {
					...error.shape,
					message: SESSION_EXPIRED_MESSAGE,
				},
			},
			{
				cause: error,
				meta: error.meta,
			},
		);
	}

	return new TRPCClientError<AppRouter>(SESSION_EXPIRED_MESSAGE, {
		cause: error,
		meta: error.meta,
	});
}
